<template>
  <section class="header_wrap" :class="{ 'with-warning': !localIsExtensionInstalled, 'header_wrap--magicone': isMagicOne }">
    <div v-if="!localIsExtensionInstalled" class="extension-warning">
      🚨 확장 프로그램이 아직 설치되지 않았어요! 필요한 기능을 바로 이용하려면 지금 다운로드하세요!
      <a href="https://chromewebstore.google.com/detail/idkahagphdclcilpdofbcapdphnghgli?utm_source=item-share-cb"
         target="_blank"
         @click="startCheckingForExtension">
        <p class="link"> 받으러 가기 ⬇️</p>
      </a>
    </div>

    <div class="side_logo">
      <router-link to="/app" class="logo-text">
        {{ siteName }}
      </router-link>
      <p v-if="isDomesinOnly" class="domaesin_badge">도매의신자동화 계정</p>
    </div>

    <div class="header_content">
      <div class="left_side">
        <div class="expire_date">
          <p class="remainTime" v-html="remainTime.replace(/\n/g, '<br />')"></p>
        </div>
      </div>

      <div class="right_side">
        <div class="greeting" v-if="userName">
          <div class="greeting_content">
            {{ userName }} ({{ displayUserId || 'N/A' }}) 환영합니다. 즐거운 하루 되세요. <br>
            <span v-if="isEmployeeAccount" class="account_type">
              [본계정: {{ mainUserId }} / 직원계정: {{ subUserId }}]
            </span>
            <span v-else class="account_type">
              [본계정: {{ displayUserId || 'N/A' }}]
            </span>
            <span>
              현재 탭 번호 : {{ this.tabId }}
            </span>
            <div v-html="userComment"></div>
          </div>
        </div>




        <div class="version_info" v-if="appVersion">
          <span>v{{ formattedVersion }}</span>
        </div>

        <button class="approval">
          <router-link to="/plan"> 결제하기</router-link>
        </button>
        <button class="balance" @click="openDepositDetail = true">
          <span>포인트</span>
          <p>
            <strong>{{ depositInfo?.deposit.toLocaleString() }}</strong> 원
          </p>
        </button>
        <button class="alert" @click="openAlert()">
          <div class="svg_container">
            <svg_alert />
            <div class="badge" v-if="!alert">.</div>
          </div>
          <!--          <div class="svg_container">
                      <svg_work_status />
                      <div class="badge" v-if="!alert && !visitUpload && socketStore.status !== 'WAIT'">
                        .
                      </div>
                    </div>-->
        </button>
        <button class="logout" @click="setLogout">
          <img src="/assets/images/app/layout/logout.svg" alt="logout" title="로그아웃" />
        </button>
      </div>
    </div>

    <Alert v-if="alert" @closeAlert="closeAlert" />
    <DepositDetail v-if="openDepositDetail" :depositInfo="depositInfo" @closeDepositDetail="closeDepositDetail"
                   v-click-outside="closeDepositDetail" />

    <!-- ✅ Fix: Pass `removeToast` properly -->
    <PccToast :toastList="toastList" @removeToast="removeToast" />
  </section>
</template>

<script>
import dayjs from 'dayjs';
import Alert from '../components/Alert';
import DepositDetail from '../components/DepositDetail';
import PccToast from '../components/PccToast';
import svg_alert from '@/components/svg/svg_alert';
/*
import svg_work_status from '@/components/svg/svg_work_status';
*/
import { accountAPI } from '@/api'; //dashboardApi
import chromeExAPI from '@/chromeExAPI';
import { getTabId } from '@/packaging/vueWsEcho';

export default {
  props: {
    isExtensionInstalled: Boolean
  },
  components: {
    Alert,
    DepositDetail,
    PccToast,
    svg_alert
    /*
        svg_work_status
    */
  },
  data() {
    return {
      remainTime: '확인 중입니다.',
      alert: false,
      visitUpload: false,
      depositInfo: null,
      openDepositDetail: false,
      pcc: '',
      receiverName: '',
      receiverTelNo: '',
      toastList: [],
      userName: '',
      userId: '',
      extensionCheckInterval: null,
      localIsExtensionInstalled: this.isExtensionInstalled,
      appVersion: null,
      isEmployeeAccount: false,
      mainUserId: '',
      subUserId: '',
      tabId: ''

    };
  },
  created() {
    this.getDepositInfo();
    if (this.$route.query['ResultCode'] === '3001') {
      this.checkPaymentAfter();
    }

    /*
        setInterval(() => this.updateRemainTime(), 1000);
    */
  },
  async mounted() {
    this.checkExtensionStatus();
    const cookieUserName = this.getCookie('userName');
    if (cookieUserName) {
      this.userName = cookieUserName;
    } else {
      const { user } = this.authStore;
      if (user) {
        this.userName = user.userName && user.userName.trim() ? user.userName : '회원';
        this.setCookie('userName', this.userName, 1);
      }
    }

    // userId 설정 (여러 경로에서 시도)
    await this.setUserId();

    // 직원계정 정보 설정
    this.isEmployeeAccount = localStorage.getItem('isEmployeeAccount') === 'true';
    if (this.isEmployeeAccount) {
      this.mainUserId = localStorage.getItem('loginUserId') || '';
      this.subUserId = localStorage.getItem('subUserId') || '';
    }

    // 버전 정보 가져오기
    this.appVersion = this.authStore.version || localStorage.getItem('version');

    this.tabId = getTabId();
  },
  beforeDestroy() {
    if (this.extensionCheckInterval) {
      clearInterval(this.extensionCheckInterval);
      this.extensionCheckInterval = null;
    }
  },
  computed:{
    isDomesinOnly() {
      // authStore.user 또는 localStorage에서 isDomesinOnly 확인
      const user = this.authStore.user;
      if (user && user.isDomesinOnly) {
        return true;
      }
      try {
        const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
        if (storedUser && storedUser.isDomesinOnly) {
          return true;
        }
      } catch (e) {
        // 무시
      }
      return false;
    },
    sideLogoText() {
      const host = window.location.hostname;
      if (host.includes('daenlabs.kr')) return '다엔랩스';
      if (host.includes('connectone07.co.kr')) return '커넥트원';
      if (host.includes('crosssell.co.kr')) return '크로스셀';
      return '오버링크';
    },
    siteName() {
      const host = window.location.hostname;
      if (host.includes('magicone.kr') || host === 'localhost') return '매직원';
      if (host.includes('omarket.kr')) return '셀리오마켓';
      if (host.includes('daenlabs.kr')) return '다엔랩스';
      if (host.includes('connectone07.co.kr')) return '커넥트원';
      if (host.includes('kcode.store')) return '케이코드';
      if (host.includes('crosssell.co.kr')) return '크로스셀';
      if (host.includes('overlink.kr')) return '오버링크';
      if (host.includes('osonupload.com')) return '오손업로드';
      if (host.includes('smartcross.kr')) return '스마트크로스';
      return '오버링크';
    },
    isMagicOne() {
      const host = window.location.hostname;
      return host.includes('magicone.kr') || host === 'localhost';
    },
    logoSrc() {
      const host = window.location.hostname;

      if (host === 'localhost') {
        return '/assets/images/common/logo_o.png';
      }

      if (host.includes('omarket.kr')) {
        return '/assets/images/common/logo.png';
      } else if (host.includes('daenlabs.kr')) {
        return '/assets/images/common/logo_s.png';
      } else if (host.includes('kimmanager.co.kr')) {
        return '/assets/images/common/logo_j.png';
      } else if (host.includes('connectone07.co.kr')) {
        return '/assets/images/common/logo_i.png';
      } else if (host.includes('kcode.store')) {
        return '/assets/images/common/logo_m.png';
      } else if (host.includes('crosssell.co.kr')) {
        return '/assets/images/common/logo_c.png';
      } else if (host.includes('overlink.kr')) {
        return '/assets/images/common/logo_o.png';
      } else if (host.includes('zijyasssssell.com')) {
        return '/assets/images/common/logo_z.png';
      } else if (host.includes('osonupload.com') || host.includes('magicone.kr')) {
        return '/assets/images/common/logo_os.png';
      } else if (host.includes('smartcross.kr')) {
        return '/assets/images/common/logo_sc.png';
      } else {
        return '/assets/images/common/logo.png';
      }
    }
    ,
    userComment() {
      const host = window.location.hostname;

      if (host.includes('omarket.kr')) {
        return '';
      } else if (host.includes('daenlabs.kr')) {
        return '';
      } else if (host.includes('kimmanager.co.kr')) {
        return '';
      } else if (host.includes('connectone07.co.kr')) {
        return ``;
      } else if (host.includes('kcode.store')) {
        return '';
      } else {
        return ``;
      }
    },
    formattedVersion() {
      if (!this.appVersion) return '';

      // 버전 문자열에서 숫자.숫자.숫자.숫자 패턴까지만 추출
      const match = this.appVersion.match(/^(\d+\.\d+\.\d+\.\d+)/);
      if (match) {
        return match[1];
      }

      // 패턴이 맞지 않으면 원본 반환 (또는 빈 문자열)
      return this.appVersion;
    },
    displayUserId() {
      // data의 userId가 있으면 사용, 없으면 computed로 가져오기
      if (this.userId) return this.userId;
      const user = this.authStore.user;
      if (!user) {
        // localStorage에서도 시도
        try {
          const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
          if (storedUser && storedUser.userId) {
            return String(storedUser.userId).trim();
          }
        } catch (e) {
          // 무시
        }
        return '';
      }
      // userId 필드 확인
      const id = user.userId || user.userAccountId || user.id;
      return id ? String(id).trim() : '';
    }

  },
  methods: {
    updateRemainTime() {
      const user = this.depositInfo;

      const expireDate = user?.endDate;
      const joinDate = user?.joinDate;

      const now = dayjs();
      const join = dayjs(joinDate);
      const expire = dayjs(expireDate);
      const thresholdDate = dayjs('2025-03-26');

      const freePeriod = join.isAfter(thresholdDate.subtract(1, 'day')) ? 21 : 14;
      const freeEnd = join.add(freePeriod, 'day');               // 무료 끝나는 날
      const paidStart = freeEnd;                                 // 유료 시작일

      console.log('유료 시작일 +' + paidStart.format('YYYY-MM-DD').toString());
      const remainingFreeDays = freeEnd.diff(now, 'day');
      const remainingPaidDays =
        /* now.isBefore(paidStart) ?  expire.diff(paidStart, 'day') :*/ expire.diff(now, 'day');
      const remainingPaidTotalHours = expire.diff(now, 'hour');
      const remainingPaidHours = remainingPaidTotalHours % 24;
      const remainTimeStr =
        remainingPaidDays > 0
          ? `${remainingPaidDays}일 ${remainingPaidHours}시`
          : remainingPaidTotalHours > 0
            ? `${remainingPaidTotalHours}시`
            : null;

      if (remainingFreeDays > 0 && now.isBefore(freeEnd) && remainingPaidDays > 0) {
        this.remainTime = `📢 총 사용 기간이 ${remainTimeStr} 남았습니다. (정품소명가능) `;
      } else if (remainingFreeDays <= 0 && remainingPaidDays > 0) {
        this.remainTime = `📢 유료 사용기간이 ${remainTimeStr} 남았습니다. (정품소명가능)`;
      } else if (remainingFreeDays > 0 && remainingPaidDays > 0) {
        // 오늘이 무료 종료일 당일이면 둘 다 보여줄 수 있음
        this.remainTime = `📢 총 사용 기간이 ${remainTimeStr} 남았습니다. (정품소명가능)`;
      } else {
        this.remainTime = '📢 사용 기간이 만료되었습니다.';
      }
    },
    async getDepositInfo() {
      const res = await accountAPI.GetUserRestrics();
      this.depositInfo = res.data;
      this.updateRemainTime();
    },
    openAlert() {
      this.alert = !this.alert;
      this.visitUpload = true;
    },
    closeAlert() {
      this.alert = false;
    },
    closeDepositDetail() {
      this.openDepositDetail = false;
    },
    checkPaymentAfter() {
      this.common.setToast('blue', 'good', '포인트 충전이 완료되었습니다.');
      this.openDepositDetail = true;
    },
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    },
    getCookie(name) {
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
        while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
        if (cookie.indexOf(name + '=') === 0) {
          return cookie.substring(name.length + 1, cookie.length);
        }
      }
      return null;
    },
    deleteCookie(cookieName) {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    },
    setLogout() {
      this.authStore.logout();
      this.deleteCookie('userName');
      this.templateStore.clearTemplate();
      this.$router.replace('/user');
    },
    async checkExtensionStatus() {
      this.localIsExtensionInstalled = await chromeExAPI.isExtensionInstalled();
      if (this.localIsExtensionInstalled) {
        clearInterval(this.extensionCheckInterval);
        this.extensionCheckInterval = null;
      }
    },
    startCheckingForExtension() {
      if (this.localIsExtensionInstalled) return;
      if (!this.extensionCheckInterval) {
        this.extensionCheckInterval = setInterval(() => {
          this.checkExtensionStatus();
        }, 1000);
      }
    },
    removeToast(index) {
      this.toastList.splice(index, 1);
    },
    async setUserId() {
      // 1. localStorage에서 로그인 시 저장한 userId 가져오기 (우선순위 1)
      const loginUserId = localStorage.getItem('loginUserId');
      if (loginUserId) {
        this.userId = String(loginUserId).trim();
        return;
      }

      // 2. authStore.user에서 가져오기
      const user = this.authStore.user;
      if (user && user.userId) {
        this.userId = String(user.userId).trim();
        return;
      }

      // 3. localStorage의 user 객체에서 가져오기
      try {
        const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
        if (storedUser && storedUser.userId) {
          this.userId = String(storedUser.userId).trim();
          return;
        }
      } catch (e) {
        // 무시
      }

      // 4. authStore에 user가 없으면 setupUser 시도
      if (!user && this.authStore.accessToken) {
        try {
          await this.authStore.setupUser();
          const updatedUser = this.authStore.user;
          if (updatedUser && updatedUser.userId) {
            this.userId = String(updatedUser.userId).trim();
            return;
          }
        } catch (e) {
          console.error('setupUser 실패:', e);
        }
      }

      // 5. 그래도 없으면 빈 문자열
      this.userId = '';
    }
  }

};
</script>


<style lang="scss">
@import '@/assets/style/app/layout/header.scss';

// MagicOne 전용 스타일
.header_wrap--magicone {
  background: #ffffff !important;
  border-bottom: 1px solid #e5e7eb;

  .side_logo {
    .logo-text {
      color: #111827 !important;
      font-weight: 800 !important;
      font-size: 28px !important;
      -webkit-text-fill-color: #111827 !important;
    }
  }

  .header_content {
    color: #111827 !important;

    * {
      color: #111827 !important;
    }
  }
}
</style>